import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';

type Props = {
  label: string;
  icon: React.ReactNode;
  value: string | number;
};

const StatisticCustomerItem = ({ label, icon, value }: Props) => {
  return (
    <ContainerStyled>
      <TextContent>
        <Text variant='H9' color='text_4_v2'>
          {label}
        </Text>
        <Text variant='H2'>{value}</Text>
      </TextContent>
      <div className='icon'>{icon}</div>
    </ContainerStyled>
  );
};

export default StatisticCustomerItem;

const ContainerStyled = styled.div`
  display: flex;
  padding: 24px 8px 24px 16px;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #ccd4dc;
  background: #fff;
  .icon {
    flex-shrink: 0;
    aspect-ratio: 1/1;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
